/**
 * Protected Route wrapper — requires authentication.
 * Syncs auth token to the API client.
 */

import { useEffect } from 'react';
import { CircularProgress, Box } from '@mui/material';
import { useRequireAuth } from '../lib/auth';
import { conciergeApi } from '../services/concierge-api-client';
import { groupsApi } from '../services/groups-api-client';
import AppLayout from './AppLayout';

export default function ProtectedRoute() {
  const { token, isLoading } = useRequireAuth();

  // Sync token to API client
  useEffect(() => {
    if (token) {
      conciergeApi.setAuthToken(token);
      groupsApi.setAuthToken(token);
    } else {
      conciergeApi.clearAuthToken();
      groupsApi.clearAuthToken();
    }
  }, [token]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return <AppLayout />;
}
